<template>
<div class="page-wrapper">
  <div>
    <!--<h3 class="title">收款单信息</h3>-->
    <!--<Row :gutter="16">-->
      <!--<Col span="6">单据状态：<span class="info">未收款</span></Col>-->
      <!--<Col span="6">审核状态：<span class="info">未提交</span></Col>-->
    <!--</Row>-->
    <!--<Row :gutter="16">-->
      <!--<Col span="6">应收金额：<span class="info error-color">{{receiptBillAmount}}</span></Col>-->
      <!--<Col span="6">实收金额：<span class="info error-color">{{receivedBillAmount}}</span></Col>-->
    <!--</Row>-->
  </div>
  <div class="mt36" >
    <h4 class="title">应收账单信息</h4>
    <div class="table-wrap" v-if="billInfo">
      <table class="ivu-table" cellspacing="0" cellpadding="0" border="0" >
        <thead>
          <tr>
            <th>应收账单编号</th>
            <th>合同号/预订单号</th>
            <th>房间/床位号</th>
            <th>费用项</th>
            <th>账单金额</th>

            <th>实收金额</th>
            <th>待收金额</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="ivu-table-column-center">{{billInfo.billNum}}</td>
            <td class="ivu-table-column-center">{{billInfo.outContractCode}}</td>
            <td class="ivu-table-column-center">{{billInfo.houseCode}}</td>
            <td class="ivu-table-column-center">{{billInfo.costCodeName}}</td>
            <td class="ivu-table-column-center">{{receiptBillAmount}}</td>

            <td class="ivu-table-column-center">{{receivedBillAmount2}}</td>
            <td class="ivu-table-column-center">{{unReceivedBillAmount2}}</td>

          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div  class="mt36" v-if=" costCode=== 'khfz' && cardsList.length">
    <h3 class="title">卡券信息</h3>
    <div class="flex">
      <span class="label">租金卡</span>
      <div class="cards  mb8" v-for="(item,i) in cardsList" :class="{checked:item.status==1}" :key="`card${i}`" @click="clickCard(i)">{{(item.money/100).toFixed(2)}}</div>
    </div>
  </div>

  <div class="mt36">
    <h3 class="title">收款</h3>
    <Row :gutter="16" class="mb16">
      <Col span="6">待收金额：<span class="info">{{unReceivedBillAmount2}}</span></Col>
      <Col span="6">卡券抵扣金额：<span class="info">{{cardAmount}}</span></Col>

      <Col span="6">本次录入金额：<span class="info">{{inputNUmber}}</span></Col>

    </Row>
    <div >
      <collection-item ref="collection" :billNum="billNum" :projectFid="projectFid" :receiptMethodList="receiptMethodList" @inputPayment = "inputPayment"  @show-img="showImg"></collection-item>
    </div>
  </div>
  <div  class="btn-wrap">
    <Button type="primary" size="large" @click="save1227" :loading="btnLoading">
      <span>提交</span>
    </Button>
  </div>
</div>

</template>

<script type="text/ecmascript-6">
import { getBillInfoByCollect, queryRentCard, savePaymentVoucher, getReceiptMethod } from 'api/accountsReceivable'
import CollectionItem from './../components/CollectionItem';

export default {
  name:'collection',
  created(){
    this.projectFid = this.$route.query.proId
    this.contractCode = this.$route.query.cCode
    this.billNum = this.$route.query.bNum
    this.oneTime = this.$route.query.oneTime
    this.getBillInfo()
  },
  activated(){
    if(this.isActive){
      this.projectFid = this.$route.query.proId
      this.contractCode = this.$route.query.cCode
      this.billNum = this.$route.query.bNum
      this.getBillInfo()
    } else {
      this.isActive = true
    }

  },
  computed:{
    unReceivedBillAmount2(){
      return (Number(this.receiptBillAmount)-Number(this.receivedBillAmount2)).toFixed(2)

    },
    tag() {
      return this.$store.state.tagsView.visitedViews.find(tag => {
        return tag.path===this.$route.path
      });
    },
    clickedCardsList(){
      let arr = []
      this.cardsList.forEach( item => {
        if(item.status === 1){
          arr.push({
            code:item.code,
            money:(item.money/100).toFixed(2),
            type:item.type
          })
        }
      })
      return arr
    },
    cardsTotal(){
      return this.clickedCardsList.reduce((sum,cur) => {
        return sum + +cur.money
      },0)
    },
  },
  data () {
    return {
      inputNUmber:0,
      receivedBillAmount2:0,
      btnLoading:false,
      isActive:false,
      imgSrc:'',
      billNum:'',
      costCode:'',
      projectFid:'',
      oneTime:0,
      verificateStatus:'未收款',
      contractCode:'',
      receiptBillAmount:0,
      receivedBillAmount:0,
      initReceivedBillAmount:0,
      cardAmount:new Number(0).toFixed(2),
      unReceivedBillAmount:new Number(0).toFixed(2),
      receiptMethodList:[],
       cardsList:[],
      billInfo:null,
      collections:[{
        index:0,
        status:1
      }],
    };
  },
  components:{
    CollectionItem
  },
  // watch:{
  //   contractCode(val){
  //     getReceiptMethod(val).then( res => {
  //       this.receiptMethodList = res.data
  //     })
  //   }
  // },
  methods:{
    addCollections(){
      let len = this.collections.length
      this.collections.push({
        index:len,
        status:1
      })
    },
    clickCard(i){
      if(this.cardsList[i].status==0){
        this.cardsList[i].status = 1
      }else {
         this.cardsList[i].status = 0
      }

      if(this.unReceivedBillAmount <= 0){
        // 租金卡总额大于房租待付 当前租卡不选  status=0，提醒
        this.cardsList[i].status = 0
        this.$Modal.warning({
          title: '消息提醒',
          content: '租金卡卡券总额大于房租待收金额，此租金卡不可选'
        });
        // 触发抵扣事件
      }else{
        this.inputPayment()
      }
    },
    closeTag(){
      if(!this.oneTime || this.oneTime === 0){
        // this.$router.push({ name: 'accountsreceivable'})
        this.$routerGo({name: 'accountsreceivable'})
      }
      //预订单收款，跳转预订单列表页面
      if(this.oneTime === 1){
        this.$router.push({name:'order',params:{targetTab:'5'}})
      }
    },
    getTotal(){
      let factPayment = +this.$refs.collection.formData.factPayment
      return  factPayment
    },
    getBillInfo(){
      getReceiptMethod(this.contractCode).then( res => {
        this.receiptMethodList = res.data
      })
      getBillInfoByCollect(this.contractCode,this.billNum).then( res => {
        this.billInfo = res.data
        this.costCode = res.data.costCode
        if(res.data.uid && res.data.costCode==='khfz'){
          queryRentCard(res.data.uid).then( res => {
            this.cardsList = res.data
            this.cardsList.forEach( item => {
              this.$set(item,'status',0)
            })
          })
        }
        this.receiptBillAmount = (res.data.receiptBillAmount/100).toFixed(2)
        this.receivedBillAmount = (res.data.receivedBillAmount/100).toFixed(2)
        this.receivedBillAmount2=(res.data.receivedBillAmount/100).toFixed(2)
        this.unReceivedBillAmount = (this.receiptBillAmount - this.receivedBillAmount).toFixed(2)
        this.initReceivedBillAmount = this.receivedBillAmount
      })
    },
    inputPayment(){
      let total = this.getTotal()
      this.receivedBillAmount = (+total + +this.initReceivedBillAmount + this.cardsTotal).toFixed(2)

      // if(+this.receivedBillAmount > +this.receiptBillAmount){
      //   this.$Modal.warning({
      //     title: '消息提醒',
      //     content: '实收金额大于应收金额，将生成多收款！'
      //   });
      //   // return
      // }
      this.cardAmount = this.cardsTotal.toFixed(2)
      this.unReceivedBillAmount = (this.receiptBillAmount - this.receivedBillAmount).toFixed(2)


      this.inputNUmber=total
    },
    showImg(img){
      this.imgSrc =img
      this.showImgKey++
    },
    save1227(){
      if(+this.receiptBillAmount > +this.receivedBillAmount && this.oneTime === 1){
        this.$Modal.confirm({
          title: '消息提醒',
          content: '实收金额小于应收金额，请重新录入收款金额！',
          onOk: () => {
            return
          }
        })
        return
      }

      if(+this.receiptBillAmount < +this.receivedBillAmount && this.oneTime === 1){
        this.$Modal.confirm({
          title: '消息提醒',
          content: '实收金额大于应收金额，请重新录入',
          onOk: () => {
            return
          }
        })
        return
      }

      if(+this.receiptBillAmount < +this.receivedBillAmount ){
        this.$Modal.confirm({
          title: '消息提醒',
          content: '实收金额大于应收金额，将生成多收款！',
          onOk: () => {
            this.save()

          }
        })
        return
      }
      this.save()

    },

    save(){

      let data = {
        billNum:this.billNum,
        costCode:this.costCode,
        contractId:this.contractCode,
      }

      if(this.clickedCardsList.length){
        let cards = this.clickedCardsList.map(item => {
          return {
            code:item.code,
            money:(item.money*100).toFixed(0),
            type:item.type
          }
        })
       data = Object.assign({},data,{rentCardCodes:cards})
      }

      let receipts = this.validateCollections()
      if(receipts){
        this.btnLoading=true
        data = Object.assign({},data,receipts)
        savePaymentVoucher(data).then( res=>{
           this.$Message.success('提交成功!');
           this.closeTag()
           this.btnLoading=false
        }).catch(res => {
          this.btnLoading=false
        })
      }
    },
    validateCollections(){
      return  this.$refs.collection.formValidate()
    }
  }
}
</script>

<style lang="css" scoped>
 .table-wrap {
  position: relative;
  border: 1px solid #dddee1;
    border-bottom: 0;
    border-right: 0;
}
table {
  width: 100%;
}
th,td {
  text-align: center;
}
.btn-wrap {
width: 100%;
text-align: center;
}
.cards {
  display: inline-block;
  width:80px;
  height: 32px;
  line-height: 32px;
  border: 1px solid #DDDEE1;
  border-radius: 2px;
  text-align: center;
  margin-left: 16px;
}
.cards.checked {
 border: 1px solid #CFA868;
}
.flex {
  display: flex;
}
.flex .label {
  flex: 0 0 60px;
}
.info {
  padding-left: 8px;
  font-weight: 600;
}
.ivu-col {
  line-height: 2.5;
}
</style>
